// ReactJS.NET needs to expose components globally, so we do this
// tslint:disable-next-line:no-var-requires
const Components = require('expose-loader?exposes=Components!./Components');
// tslint:disable-next-line:no-var-requires
const ReactJss = require('expose-loader?exposes=ReactJss!react-jss');
// tslint:disable-next-line:no-var-requires
const Styled = require('expose-loader?exposes=Styled!styled-components');
